import { makeStyles, Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import { AcnColorTheme } from "../../../assets/css/AcnColorTheme";
import other from '../../../assets/img/payment_otherBanks.png';
import qrcode from '../../../assets/img/payment_qr.png';
import scb from '../../../assets/img/payment_scb.png';
import { fontUnit } from "../../../utils/DeviceManager";

interface ChoosePaymentCard {
    title: string;
    isFee?: boolean;
    image: string;
    callBack?: any;
    selectedChannel: string;
}

export function ChoosePaymentCard(props: ChoosePaymentCard) {
    const {title, isFee, selectedChannel = false, image} = props;
    const [img, setImg] = useState(scb);

    useEffect(() => {
        if (image === 'scb') {
            setImg(scb)
        }
        if (image === 'qrcode') {
            setImg(qrcode)
        }
        if (image === 'other') {
            setImg(other)
        }
    }, []);

    const classes = useStyles();

    return <div>
        <div className={classes.card}
            title="divChannel"
            id={image}
            aria-label={image}
            role={image}
            onClick={() => {
                props.callBack(image)
            }}
            style={{
                color: selectedChannel===image? AcnColorTheme.darkBlue:'',
                border: selectedChannel===image? '2px solid #B8BEFF':'2px solid #FFFFFF',
                background: selectedChannel===image? AcnColorTheme.lightPurple : AcnColorTheme.white,
            }}
        >
            <Typography className={classes.content}>
                <Typography className={classes.title}>
                    {title}
                </Typography>
                <Typography className={classes.fee} component={'span'}>
                    {isFee ? 'อาจมีค่าธรรมเนียม' : 'ไม่มีค่าธรรมเนียม'}
                </Typography>
            </Typography>

            {
                image === 'scb' ? 
                    <img className={classes.scb} src={img} alt="icon"/>
                    :<div 
                        className={classes.iconContainer} 
                        style={{
                            background: selectedChannel===image? 
                                AcnColorTheme.darkBlue
                                :AcnColorTheme.lightPurple
                        }}>
                        <img className={classes.img} src={img} alt="icon"/>
                    </div>
            }
        </div>
    </div>
}


const useStyles = makeStyles({
    card: {
        width: '240px',
        height: '76px',
        marginRight: 8,
        fontFamily: "Prompt",
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: '8px',
        boxSizing: 'border-box',
    },
    content: {
        textAlign: "start",
        padding: '8px',
    },
    title: {
        fontWeight: 'bold',
        fontSize: fontUnit(16),
    },
    fee: {
        fontSize: fontUnit(14),
        color: AcnColorTheme.remarkGrey,
    },
    scb: {
        width: '44px',
        height: '44px',
        marginRight: '16px',
    },
    img: {
        width: '60%',
        height: '60%',
        borderRadius: '8px',
    },
    iconContainer: {
        width: '40px',
        height: '40px',
        borderRadius: '8px',
        marginRight: '16px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',    
    }
},{name: 'PaymentCard'});